type Route = string;

export const AppRoutes = {
    HOME: '/',
    ALL: '/*',
    NOT_AVAILABLE: '/not-available',
    DELIVERY: '/delivery',
    ORDER_CONFIRMATION: '/orderconfirmation',
    BONUS_POINT_HISTORY: '/point-history',
};

export const RoutingUrl = {
    home: (): Route => AppRoutes.HOME,
    notAvailable: (): Route => AppRoutes.NOT_AVAILABLE,
    delivery: (articleId: number): Route => `${AppRoutes.DELIVERY}/${articleId}`,
    orderConfirmation: (): Route => AppRoutes.ORDER_CONFIRMATION,
    bonusPointHistory: (): Route => AppRoutes.BONUS_POINT_HISTORY,
};

export const ExternalRoutes = {
    HOME: '/de',
    LOYALTY_REGISTRATION: '/de/account/loyalty',
};
